/**
 * useReferenceData Hooks
 * React Query hooks for fetching reference data
 */

import { useQuery } from '@tanstack/react-query';
import { referenceDataApi, type ReferenceDataOption } from '../services/referenceDataApi';

/**
 * Fetch availability schedules
 */
export function useAvailabilitySchedules() {
  return useQuery<ReferenceDataOption[], Error>({
    queryKey: ['reference-data', 'availability-schedules'],
    queryFn: () => referenceDataApi.getAvailabilitySchedules(),
    staleTime: 1000 * 60 * 60, // 1 hour (reference data rarely changes)
  });
}

/**
 * Fetch payer options
 */
export function usePayerOptions() {
  return useQuery<ReferenceDataOption[], Error>({
    queryKey: ['reference-data', 'payer-options'],
    queryFn: () => referenceDataApi.getPayerOptions(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}

